import {
  base,
  validations
} from "@/components/Tools/FormHelperFactory/Configurations/baseConfigurations";

export const time = {
  ...base,
  ...validations,
  format: {
    type: "text",
    strict: "true",
    default: "HH:mm:ss",
    required: true
  },
  min: {
    type: "text",
    strict: true,
    default: ""
  },
  max: {
    type: "text",
    strict: true,
    default: ""
  },
  allowedHours: {
    type: "multiselect",
    options: [...Array(24).keys()],
    default: [...Array(24).keys()],
    clearable: true
  },
  allowedMinutes: {
    type: "multiselect",
    options: [...Array(60).keys()],
    default: [...Array(60).keys()],
    clearable: true
  },
  allowedSeconds: {
    type: "multiselect",
    options: [...Array(60).keys()],
    default: [...Array(60).keys()],
    clearable: true
  },
  useSeconds: {
    type: "checkbox",
    default: false
  }
};
